export default __webpack_public_path__ + "static/media/684.69a911f8.gif";